export default __webpack_public_path__ + "static/media/confusionImg_2.2fa794fe.png";